import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sprout, Droplets, MapPin, Package } from 'lucide-react';

import { BACKEND_URL } from '../config/api';

export const ProductCard = ({ product, index = 0 }) => {
  const imageUrl = product.image_url 
    ? (product.image_url.startsWith('http') ? product.image_url : `${BACKEND_URL}${product.image_url}`)
    : 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=400';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="product-card card-hover overflow-hidden group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/products/${product.id}`}>
        {/* Image Container */}
        <div className="relative h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={product.name}
            className="product-card-image w-full h-full object-cover"
            onError={(e) => {
              e.target.src = 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=400';
            }}
          />
          <div className="absolute top-3 left-3">
            <span className="bg-primary/90 text-white text-xs font-medium px-3 py-1.5 rounded-full backdrop-blur-sm">
              {product.crop_type}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="p-5">
          <h3 className="font-heading font-semibold text-lg text-stone-900 mb-2 group-hover:text-primary transition-colors">
            {product.name}
          </h3>
          <p className="text-stone-600 text-sm mb-4 line-clamp-2">
            {product.short_description}
          </p>

          {/* Product Info */}
          <div className="grid grid-cols-2 gap-3 text-xs">
            <div className="flex items-center gap-1.5 text-stone-500">
              <Sprout className="w-3.5 h-3.5 text-primary" />
              <span>{product.germination_rate}</span>
            </div>
            <div className="flex items-center gap-1.5 text-stone-500">
              <Droplets className="w-3.5 h-3.5 text-primary" />
              <span>{product.suitable_season}</span>
            </div>
            <div className="flex items-center gap-1.5 text-stone-500">
              <MapPin className="w-3.5 h-3.5 text-primary" />
              <span className="truncate">{product.region_suitability.split(',')[0]}</span>
            </div>
            <div className="flex items-center gap-1.5 text-stone-500">
              <Package className="w-3.5 h-3.5 text-primary" />
              <span>{product.packaging_size}</span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

